import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  toString3dhdjl9yf50de as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Composer1pt8hwk95abxi as Composer,
  ComposerForUnquotedLiterals3v0rwxdudtla9 as ComposerForUnquotedLiterals,
  ComposerForUnsignedNumbers2h1dv6l9z3aef as ComposerForUnsignedNumbers,
} from './Composers.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance3v12utpo53nyi as CLASS_getInstance,
  OBJECT_getInstance1yzfkijr6copj as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClassDiscriminatorMode_NONE_getInstance2e818e0ikitep as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  access$checkEncodingConflicts$tPolymorphicKt2migrcemidykb as access$checkEncodingConflicts$tPolymorphicKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './Polymorphic.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { switchMode35g725ikhjpwv as switchMode } from './WriteMode.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import { InvalidFloatingPointEncoded3n0aum4e9o5qi as InvalidFloatingPointEncoded } from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf as get_jsonUnquotedLiteralDescriptor } from '../JsonElement.mjs';
import { Companion_getInstance18m03xf6clkk8 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  serializer3ikrxnm8b29d6 as serializer,
  serializer2lw83vwvpnyms as serializer_0,
  serializer36584sjyg5661 as serializer_1,
  serializer1q7c5q67ysppr as serializer_2,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance3sq3iu5mj6qnr as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance3jsnccejczksw as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance29d4047m08ot as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.k2s_1.b2q();
  $this.t1s(discriminator);
  $this.k2s_1.e2q(_Char___init__impl__6a9atx(58));
  $this.k2s_1.d2q();
  $this.t1s(serialName);
}
var StreamingJsonEncoderClass;
function StreamingJsonEncoder() {
  if (StreamingJsonEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static d2u(composer, json, mode, modeReuseCache) {
        var $this = this.h1s();
        $this.k2s_1 = composer;
        $this.l2s_1 = json;
        $this.m2s_1 = mode;
        $this.n2s_1 = modeReuseCache;
        $this.o2s_1 = $this.l2s_1.d1s();
        $this.p2s_1 = $this.l2s_1.e2m_1;
        $this.q2s_1 = false;
        $this.r2s_1 = null;
        $this.s2s_1 = null;
        var i = $this.m2s_1.b2_1;
        if (!($this.n2s_1 == null)) {
          if (!($this.n2s_1[i] === null) || !($this.n2s_1[i] === $this)) {
            $this.n2s_1[i] = $this;
          }
        }
        return $this;
      }
      g2o() {
        return this.l2s_1;
      }
      static t2s(output, json, mode, modeReuseCache) {
        return this.d2u(Composer(output, json), json, mode, modeReuseCache);
      }
      d1s() {
        return this.o2s_1;
      }
      m1t(descriptor, index) {
        return this.p2s_1.p2n_1;
      }
      h1t(serializer, value) {
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
          if (this.g2o().e2m_1.x2n_1) {
            serializer.y1m(this, value);
            break $l$block;
          }
          var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
          var tmp;
          if (isPolymorphicSerializer) {
            tmp = !this.g2o().e2m_1.f2o_1.equals(ClassDiscriminatorMode_NONE_getInstance());
          } else {
            var tmp_0;
            switch (this.g2o().e2m_1.f2o_1.b2_1) {
              case 0:
              case 2:
                tmp_0 = false;
                break;
              case 1:
                // Inline function 'kotlin.let' call

                var it = serializer.x1m().t1p();
                tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            tmp = tmp_0;
          }
          var needDiscriminator = tmp;
          var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.x1m(), this.g2o()) : null;
          var tmp_1;
          if (isPolymorphicSerializer) {
            var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (value == null) {
                var message = 'Value for serializer ' + toString_0(serializer.x1m()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                throw IllegalArgumentException().s2(toString_0(message));
              } else {
                break $l$block_0;
              }
            }
            var actual = findPolymorphicSerializer(casted, this, value);
            tmp_1 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
          } else {
            tmp_1 = serializer;
          }
          var actualSerializer = tmp_1;
          if (!(baseClassDiscriminator == null)) {
            access$checkEncodingConflicts$tPolymorphicKt(this.g2o(), serializer, actualSerializer, baseClassDiscriminator);
            checkKind(actualSerializer.x1m().t1p());
            var serialName = actualSerializer.x1m().a1o();
            this.r2s_1 = baseClassDiscriminator;
            this.s2s_1 = serialName;
          }
          actualSerializer.y1m(this, value);
        }
      }
      o1r(descriptor) {
        var newMode = switchMode(this.l2s_1, descriptor);
        if (!(newMode.w2t_1 === _Char___init__impl__6a9atx(0))) {
          this.k2s_1.e2q(newMode.w2t_1);
          this.k2s_1.z2p();
        }
        var discriminator = this.r2s_1;
        if (!(discriminator == null)) {
          var tmp0_elvis_lhs = this.s2s_1;
          encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.a1o() : tmp0_elvis_lhs);
          this.r2s_1 = null;
          this.s2s_1 = null;
        }
        if (this.m2s_1.equals(newMode)) {
          return this;
        }
        var tmp1_safe_receiver = this.n2s_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.b2_1];
        return tmp2_elvis_lhs == null ? StreamingJsonEncoder().d2u(this.k2s_1, this.l2s_1, newMode, this.n2s_1) : tmp2_elvis_lhs;
      }
      p1r(descriptor) {
        if (!(this.m2s_1.x2t_1 === _Char___init__impl__6a9atx(0))) {
          this.k2s_1.a2q();
          this.k2s_1.c2q();
          this.k2s_1.e2q(this.m2s_1.x2t_1);
        }
      }
      i1s(descriptor, index) {
        switch (this.m2s_1.b2_1) {
          case 1:
            if (!this.k2s_1.y2p_1) {
              this.k2s_1.e2q(_Char___init__impl__6a9atx(44));
            }

            this.k2s_1.b2q();
            break;
          case 2:
            if (!this.k2s_1.y2p_1) {
              var tmp = this;
              var tmp_0;
              if ((index % 2 | 0) === 0) {
                this.k2s_1.e2q(_Char___init__impl__6a9atx(44));
                this.k2s_1.b2q();
                tmp_0 = true;
              } else {
                this.k2s_1.e2q(_Char___init__impl__6a9atx(58));
                this.k2s_1.d2q();
                tmp_0 = false;
              }
              tmp.q2s_1 = tmp_0;
            } else {
              this.q2s_1 = true;
              this.k2s_1.b2q();
            }

            break;
          case 3:
            if (index === 0)
              this.q2s_1 = true;
            if (index === 1) {
              this.k2s_1.e2q(_Char___init__impl__6a9atx(44));
              this.k2s_1.d2q();
              this.q2s_1 = false;
            }

            break;
          default:
            if (!this.k2s_1.y2p_1) {
              this.k2s_1.e2q(_Char___init__impl__6a9atx(44));
            }

            this.k2s_1.b2q();
            this.t1s(getJsonElementName(descriptor, this.l2s_1, index));
            this.k2s_1.e2q(_Char___init__impl__6a9atx(58));
            this.k2s_1.d2q();
            break;
        }
        return true;
      }
      i1t(descriptor, index, serializer, value) {
        if (!(value == null) || this.p2s_1.u2n_1) {
          super.i1t(descriptor, index, serializer, value);
        }
      }
      v1s(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_0;
          var tmp_1 = this.k2s_1;
          if (tmp_1 instanceof ComposerForUnsignedNumbers()) {
            tmp_0 = this.k2s_1;
          } else {
            var tmp0 = this.k2s_1.x2p_1;
            var p1 = this.q2s_1;
            tmp_0 = new (ComposerForUnsignedNumbers())(tmp0, p1);
          }
          var tmp$ret$1 = tmp_0;
          tmp = StreamingJsonEncoder().d2u(tmp$ret$1, this.l2s_1, this.m2s_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_2;
          var tmp_3 = this.k2s_1;
          if (tmp_3 instanceof ComposerForUnquotedLiterals()) {
            tmp_2 = this.k2s_1;
          } else {
            var tmp0_0 = this.k2s_1.x2p_1;
            var p1_0 = this.q2s_1;
            tmp_2 = new (ComposerForUnquotedLiterals())(tmp0_0, p1_0);
          }
          var tmp$ret$3 = tmp_2;
          tmp = StreamingJsonEncoder().d2u(tmp$ret$3, this.l2s_1, this.m2s_1, null);
        } else if (!(this.r2s_1 == null)) {
          // Inline function 'kotlin.apply' call
          this.s2s_1 = descriptor.a1o();
          tmp = this;
        } else {
          tmp = super.v1s(descriptor);
        }
        return tmp;
      }
      k1s() {
        this.k2s_1.g2q('null');
      }
      l1s(value) {
        if (this.q2s_1) {
          this.t1s(value.toString());
        } else {
          this.k2s_1.p2q(value);
        }
      }
      m1s(value) {
        if (this.q2s_1) {
          this.t1s(value.toString());
        } else {
          this.k2s_1.k2q(value);
        }
      }
      n1s(value) {
        if (this.q2s_1) {
          this.t1s(value.toString());
        } else {
          this.k2s_1.m2q(value);
        }
      }
      o1s(value) {
        if (this.q2s_1) {
          this.t1s(value.toString());
        } else {
          this.k2s_1.n2q(value);
        }
      }
      p1s(value) {
        if (this.q2s_1) {
          this.t1s(value.toString());
        } else {
          this.k2s_1.o2q(value);
        }
      }
      q1s(value) {
        if (this.q2s_1) {
          this.t1s(value.toString());
        } else {
          this.k2s_1.i2q(value);
        }
        if (!this.p2s_1.z2n_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value, toString_0(this.k2s_1.x2p_1));
        }
      }
      r1s(value) {
        if (this.q2s_1) {
          this.t1s(value.toString());
        } else {
          this.k2s_1.j2q(value);
        }
        if (!this.p2s_1.z2n_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value, toString_0(this.k2s_1.x2p_1));
        }
      }
      s1s(value) {
        this.t1s(toString(value));
      }
      t1s(value) {
        return this.k2s_1.q2q(value);
      }
      u1s(enumDescriptor, index) {
        this.t1s(enumDescriptor.x1p(index));
      }
    }
    initMetadataForClass($, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder(), AbstractEncoder()]);
    StreamingJsonEncoderClass = $;
  }
  return StreamingJsonEncoderClass;
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.u1p() && get_unsignedNumberDescriptors().y2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.u1p() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer(Companion_getInstance()).x1m(), serializer_0(Companion_getInstance_0()).x1m(), serializer_1(Companion_getInstance_1()).x1m(), serializer_2(Companion_getInstance_2()).x1m()]);
  }
}
//region block: exports
export {
  StreamingJsonEncoder as StreamingJsonEncoder1wswwd0g47gwe,
  get_isUnsignedNumber as get_isUnsignedNumber3dxwaa3af8ncr,
};
//endregion

//# sourceMappingURL=StreamingJsonEncoder.mjs.map
